import { Injectable } from '@angular/core';

import { DriverLeadTotalsDto, FleetLogoDto } from '@app/core/driver-wig.model';
import { IDriverWigService } from '@app/core/services/interface/IDriverWigService';
import { ServiceFactory } from '@app/core/services/service.factory';
import { FleetMatchup, WeeklyCompetitionDetails } from './wig-weekly-competition-details.model';

@Injectable()
export class WigWeeklyCompetitionDetailsService {
  driverWigService: IDriverWigService;

  constructor(private serviceFactory: ServiceFactory) {
    this.driverWigService = this.serviceFactory.getDriverWigService();
  }

  async getWeeklyCompetitionDetails(driverId: string): Promise<WeeklyCompetitionDetails[]> {
    let battleGraphTitle: string;
    let fleet: string;
    const result: WeeklyCompetitionDetails[] = [];

    await this.driverWigService.getFleetWeekly(driverId).then((data) => {
      battleGraphTitle =
        data != null ? (data.battles.length > 0 ? data.battles[0].graphTitle : '') : '';
      fleet = data != null ? data.fleet : null;
    });

    // Core information
    const [driverCompetitionDetails, fleetCompetitionDetails] = await Promise.all([
      this.driverWigService.getDriverCompetitionDetails(driverId),
      this.driverWigService.getFleetCompetitionDetails(fleet),
    ]);

    // Additional information
    const driverLeadTotalsPromises: Promise<DriverLeadTotalsDto[]>[] = [];
    const calledConferencePromises: Promise<boolean>[] = [];

    driverCompetitionDetails.forEach((value) => {
      driverLeadTotalsPromises.push(
        this.driverWigService.getDriverWeeklyLeadTotals(driverId, value.weekStart)
      );

      calledConferencePromises.push(
        this.driverWigService.getCalledConference(driverId, value.weekStart)
      );
    });

    const competingFleetTeamLogoPromises: Promise<FleetLogoDto>[] = [];

    fleetCompetitionDetails.forEach((value) => {
      competingFleetTeamLogoPromises.push(
        value.competingFleet
          ? this.driverWigService.getFleetLogo(value.competingFleet.fleet)
          : Promise.resolve(null)
      );
    });

    const [
      driverLeadTotalsResults,
      calledConferenceResults,
      competingFleetTeamLogoResults,
      fleetTeamLogoResult,
    ] = await Promise.all([
      Promise.all(driverLeadTotalsPromises),
      Promise.all(calledConferencePromises),
      Promise.all(competingFleetTeamLogoPromises),
      this.driverWigService.getFleetLogo(fleet),
    ]);

    // Build Matchup information
    for (let i = 0; i < fleetCompetitionDetails.length; i++) {
      const item = fleetCompetitionDetails[i];

      const fleetMatchup: FleetMatchup = {
        competingFleet: item.competingFleet ? item.competingFleet.fleet : null,
        competingFleetCompetition:
          item.competingFleet && item.hasCompData ? item.competingFleet.competition : null,
        competingFleetTeamLogo: item.competingFleet
          ? competingFleetTeamLogoResults[i].teamLogo
          : null,
        competingFleetTieBreaker:
          item.competingFleet && item.hasCompData ? item.competingFleet.tieBreaker : null,
        competitionHeader: battleGraphTitle,
        fleet: item.fleet,
        fleetCompetition: item.hasCompData ? item.competition : null,
        fleetTeamLogo: fleetTeamLogoResult.teamLogo,
        fleetTieBreaker: item.hasCompData ? item.tieBreaker : null,
        hasCompData: item.hasCompData,
        progress: item.progress,
        usedTiebreaker: item.usedTiebreaker,
        winningFleet: item.winner,
      };

      const weeklyCompetitionDetails: WeeklyCompetitionDetails = {
        fleetMatchup: fleetMatchup,
        weekStartDate: item.weekStart,
      };

      result.push(weeklyCompetitionDetails);
    }

    // Build My Stats information
    for (let i = 0; i < driverCompetitionDetails.length; i++) {
      const item = driverCompetitionDetails[i];

      let weeklyCompetitionDetails: WeeklyCompetitionDetails = result.find(
        (value) => value.weekStartDate === item.weekStart
      );

      if (weeklyCompetitionDetails) {
      } else {
        weeklyCompetitionDetails = {
          fleetMatchup: undefined,
          weekStartDate: item.weekStart,
        };

        result.push(weeklyCompetitionDetails);
      }
    }

    // Sort by Week ascending
    result.sort((a, b) => {
      return a.weekStartDate.valueOf() > b.weekStartDate.valueOf()
        ? 1
        : a.weekStartDate.valueOf() < b.weekStartDate.valueOf()
        ? -1
        : 0;
    });

    return result;
  }
}
